import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

export default class InterviewImage extends Component {
  render() {
    return (
      <div className={css(styles.container)}>
        <img src={this.props.src} className={css(styles.image)} />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    lineHeight: '24px',
    [Theme.mobile_query]: {
      margin: '0px auto',
      width: '100%',
    }
  },
  image: {
    margin: '50px auto',
    width: '100%',
  },
});



// WEBPACK FOOTER //
// ./src/components/InterviewImage/index.js